/* Euro Fiber OP — animations douces : apparition au défilement, survol des cartes, boutons */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SINGLE = [
    '.ef-section-heading', '.ef-about-copy', '.ef-about-art', '.ef-contact-copy', '.ef-form',
    '.ef-seo-guide-follow', '.efo-packs__head', '.efo-packs__more',
    '.product-recommendations', '.jdgm-widget'
  ];
  var GRIDS = [
    '.ef-grid', '.ef-products-grid', '.ef-values-grid', '.ef-seo-guide-grid', '.ef-reassurance-grid',
    '.efo-packs__grid', '.product-grid', '.ef-faq-list'
  ];
  var CARDS = ['.product-card', '.ef-product', '.ef-cat', '.efo-pack', '.collection-card'];
  var BUTTONS = [
    '.ef-button', '.efo-pack__btn', '.euf-header__nav-cta', '.euf-header__mega-intro a',
    '.add-to-cart-button', 'button[name="add"]', '.cart__checkout-button', '#checkout'
  ];

  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function decorate(root) {
    qsa(CARDS.join(','), root).forEach(function (el) {
      if (el.dataset.efoHover) return;
      el.dataset.efoHover = '1';
      el.classList.add('efo-hover');
      var img = el.querySelector('img');
      if (img && img.parentElement && !img.closest('.card-gallery')) img.parentElement.classList.add('efo-zoomwrap');
      var gal = el.querySelector('.card-gallery');
      if (gal) gal.classList.add('efo-zoomwrap');
    });
    qsa(BUTTONS.join(','), root).forEach(function (el) { el.classList.add('efo-btn'); });
  }

  function reveal(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var vh = window.innerHeight || 800;
    var io = reveal.io || (reveal.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('efo-in'); reveal.io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }));

    function prep(el, delay) {
      if (el.dataset.efoReveal) return;
      el.dataset.efoReveal = '1';
      // N'anime que ce qui est sous la ligne de flottaison : rien ne « clignote » au chargement
      if (el.getBoundingClientRect().top < vh * 0.92) return;
      el.style.setProperty('--efo-delay', (delay || 0) + 's');
      el.classList.add('efo-reveal');
      io.observe(el);
    }

    qsa(SINGLE.join(','), root).forEach(function (el) { prep(el, 0); });
    qsa(GRIDS.join(','), root).forEach(function (grid) {
      var row = 0, lastTop = null;
      Array.prototype.forEach.call(grid.children, function (child, i) {
        var top = Math.round(child.getBoundingClientRect().top);
        if (lastTop !== null && top !== lastTop) row = 0;
        lastTop = top;
        prep(child, Math.min(row * 0.07, 0.35));
        row++;
      });
    });

    // Autres pages (FAQ, à propos, mentions…) : chaque section après la première apparaît en douceur
    var tpl = (document.querySelector('main[data-template]') || {}).dataset;
    if (tpl && tpl.template && !/^(index|collection|product|cart|search)/.test(tpl.template)) {
      qsa('main .shopify-section', root).slice(1).forEach(function (s) { prep(s, 0); });
    }
  }

  // Filet de sécurité : défilement rapide, ancre (#ef-contact), touche Fin… tout ce qui est déjà
  // passé au-dessus ou dans l'écran est révélé, même si l'observateur n'a pas eu le temps de le voir.
  var ticking = false;
  function sweep() {
    ticking = false;
    var limit = (window.innerHeight || 800) * 0.95;
    qsa('.efo-reveal:not(.efo-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < limit) {
        el.classList.add('efo-in');
        if (reveal.io) reveal.io.unobserve(el);
      }
    });
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(sweep); }
  }, { passive: true });
  window.addEventListener('hashchange', sweep);
  window.addEventListener('load', sweep);

  // Badge panier qui rebondit après un ajout
  function bumpCart() {
    var b = document.querySelector('.euf-header__cart b, .euf-header__cart');
    if (!b) return;
    b.classList.remove('efo-bump'); void b.offsetWidth; b.classList.add('efo-bump');
  }
  document.addEventListener('cart:update', bumpCart);
  document.addEventListener('cart:updated', bumpCart);

  function init() {
    decorate(document);
    reveal(document);
    // Contenus chargés après coup (recommandations, avis, filtres de collection)
    if ('MutationObserver' in window) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { decorate(document); reveal(document); }, 150);
      }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
